import PropTypes from "prop-types";

const TagType = PropTypes.shape({
  name: PropTypes.string
});

export default TagType;
